<template lang="pug">
#CrearOT
    b-button(
        variant="action"
        @click="showModal = true"
        :disabled="loading"
    )
        b-spinner(v-if="loading" small)
        span {{ loading ? ' Procesando...' : ' Revaluar OT' }}
    
    b-modal(
        v-model="showModal"
        title="Revaluar Orden de Trabajo"
        @hidden="showModal = false"
        modal-class="modal-md"
    )
        p ¿Está seguro que desea revaluar la Orden de Trabajo de esta Oportunidad de Venta?
        p.text-muted El sistema volverá a evaluar el estado y los criterios de la OT asociada.
        
        template(#modal-footer)
            .d-flex(style="justify-content: space-between; width: 100%;")
                button.btn.d-block.btn-secondary.btn-sm(
                    type="button"
                    @click="showModal = false"
                ) Cancelar
                button.btn.d-block.btn-primary.btn-sm(
                    type="button"
                    @click="confirmRevaluarOT"
                    :disabled="loading"
                )
                    b-spinner(v-if="loading" small)
                    span {{ loading ? ' Procesando...' : ' Aceptar' }}
</template>

<script>

import { mapActions } from 'vuex';

export default {
    name: 'RevaluarOT',
    props: {
        dataOv: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showModal: false,
            loading: false,
        }
    },
    methods: {
        ...mapActions('OTStore', ['revaluarOT']),
        async confirmRevaluarOT() {
            try {
                this.loading = true;
                const response = await this.revaluarOT({ ot: this.dataOv.ot });
                if (response.data.code !== 200) {
                    this.$bvToast.toast('Error al revaluar OT', {
                        variant: 'error',
                        title: 'Error',
                    });
                }
                if (response.data.code === 200) {
                    this.$bvToast.toast('OT revaluada con éxito', {
                        variant: 'success',
                        title: 'Éxito',
                    });
                    this.showModal = false;
                }
            } catch (error) {
                console.error('Error al revaluar OT:', error);
                this.$bvToast.toast('Error al revaluar OT', {
                    variant: 'danger',
                });
            } finally {
                this.loading = false;
            }
        }
    }
}

</script>

